<ng-container *ngIf="errors.server; else errorElse">
  <ng-container *ngIf="errors.length == 1; else listaErroresServidor">
    <ng-container *ngTemplateOutlet="printError; context: { error: errors.server[0] }"></ng-container>
  </ng-container>
  <ng-template #listaErroresServidor>
    <ul class="plyca-error-list">
      <li *ngFor="let error of errors.server">
        <ng-container *ngTemplateOutlet="printError; context: { error: error }"></ng-container>
      </li>
    </ul>
  </ng-template>
</ng-container>
<ng-template #errorElse>
  <div *ngIf="errors.required">
    {{ 'Forms.error.required' | translate }}
  </div>
  <div *ngIf="errors.minlength">
    {{ 'Forms.error.minlength' | translate: { actualLength: errors.minlength.actualLength, requiredLength: errors.minlength.requiredLength } }}
  </div>
  <div *ngIf="errors.maxlength">
    {{ 'Forms.error.maxlength' | translate: { actualLength: errors.maxlength.actualLength, requiredLength: errors.maxlength.requiredLength } }}
  </div>
  <div *ngIf="errors.email || errors.pattern">
    {{ 'Forms.error.format' | translate }}
  </div>
</ng-template>

<ng-template #printError let-error="error">
  <ng-container *ngIf="error.result !== ERRORTYPE.EXCEPTION; else validationException">
    <span [innerHTML]="error.message" class="kk">
    </span>
  </ng-container>
</ng-template>
<ng-template #validationException>
  {{'Forms.error.exception' | translate }}
</ng-template>